import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
function ProtectedRoutes({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (() => {
      const auth = localStorage.getItem("Token");
      if (!auth) {
        navigate("/");
      }
      setLoading(false)
    })();
  }, [navigate]);
  return loading?null:children;
}

export default ProtectedRoutes;
